import { createSelector } from 'reselect'

const formatUser = (user) => ({
  ...user,
  name: `${user.firstName} ${user.lastName}`,
  status: user.status.toLowerCase(),
})

const isActiveUser = ({ status }) => {
  return status.toLowerCase() === 'active'
}

const getAddingUser = ({ userManagement }) => userManagement.addingUser
const getDeactivatingUser = ({ userManagement }) => userManagement.deactivatingUser
const getFetchingManagedUsers = ({ userManagement }) => userManagement.fetchingManagedUsers
const getManagedUsers = ({ userManagement }) => userManagement.managedUsers
const getRegisteringManagedUser = ({ userManagement }) => userManagement.registeringManagedUser
const getRegisterManagedUserError = ({ userManagement }) => userManagement.registerManagedUserError
const getResendingUserInvite = ({ userManagement }) => userManagement.resendingUserInvite
const getRoleOptions = ({ userManagement }) => userManagement.userRoles
const getUpdatingUser = ({ userManagement }) => userManagement.updatingUser
const getUpdatedManagedUsersListFlag = ({ userManagement }) =>
  userManagement.isUpdatedManagedUsersList

const userManagementSelectors = {
  getActiveManagedUsers: createSelector([getManagedUsers], (managedUsers) => {
    return managedUsers.filter(isActiveUser).map(formatUser)
  }),
  getAddingUser: createSelector([getAddingUser], (addingUser) => addingUser),
  getDeactivatingUser: createSelector(
    [getDeactivatingUser],
    (deactivatingUser) => deactivatingUser,
  ),
  getFetchingManagedUsers: createSelector(
    [getFetchingManagedUsers],
    (fetchingManagedUsers) => fetchingManagedUsers,
  ),
  getUpdatedManagedUsersListFlag: createSelector(
    [getUpdatedManagedUsersListFlag],
    (isUpdatedManagedUsersList) => isUpdatedManagedUsersList,
  ),

  getManagedUsers: createSelector([getManagedUsers], (managedUsers) => {
    return managedUsers.map((user) => ({
      ...user,
      name: `${user.firstName} ${user.lastName}`,
      status: user.status.toLowerCase(),
    }))
  }),
  getRegisteringManagedUser: createSelector(
    [getRegisteringManagedUser],
    (registeringManagedUser) => registeringManagedUser,
  ),
  getRegisterManagedUserError: createSelector(
    [getRegisterManagedUserError],
    (registerManagedUserError) => registerManagedUserError,
  ),
  getResendingUserInvite: createSelector(
    [getResendingUserInvite],
    (resendingUserInvite) => resendingUserInvite,
  ),
  getRoleOptions: createSelector([getRoleOptions], (roleOptions) => roleOptions),
  getUpdatingManagedUsers: createSelector(
    [getAddingUser, getDeactivatingUser, getResendingUserInvite, getUpdatingUser],
    (addingUser, deactivatingUser, resendingUserInvite, updatingUser) => {
      return addingUser || deactivatingUser || resendingUserInvite || updatingUser
    },
  ),
}

export default userManagementSelectors
